import React from 'react';

import { SVGComponentProps } from './svg.types';

const QuizSVG = ({ fill = '#878A92', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M16.3125 1.99998H14.2233V5H3.77652V1.99998H1.68734C1.41015 1.99998 1.1445 2.10545 0.948626 2.29295C0.752754 2.48045 0.642578 2.73476 0.642578 3.00009V16.9999C0.642578 17.2652 0.752754 17.5195 0.948626 17.707C1.1445 17.8945 1.41017 18 1.68734 18H16.3121C16.5893 18 16.8549 17.8945 17.0508 17.707C17.2467 17.5195 17.3569 17.2652 17.3569 16.9999V3.00009C17.3569 2.73475 17.2467 2.48045 17.0508 2.29295C16.8549 2.10545 16.5896 1.99998 16.3125 1.99998ZM12.6565 3.49999H5.34411L5.34394 1.99998H6.91091C6.91091 1.28546 7.30912 0.6252 7.95567 0.267941C8.60207 -0.0893137 9.3985 -0.0893137 10.0448 0.267941C10.6914 0.625196 11.0896 1.28546 11.0896 1.99998H12.6566L12.6565 3.49999Z"
        fill={fill}
      />
    </svg>
  );
};

export default QuizSVG;
